import { Link } from "react-router-dom";
import { TitleItem } from "@/mocks/titles";
import { typeLabel } from "@/utils/content";

interface MovieCardProps {
  item: TitleItem;
  compact?: boolean;
}

export default function MovieCard({ item, compact = false }: MovieCardProps) {
  if (compact) {
    return (
      <Link
        to={`/detail/${item.id}`}
        className="group flex items-center gap-3 rounded-lg p-2 transition-colors duration-300 hover:bg-background-100"
      >
        <div className="relative h-20 w-14 shrink-0 overflow-hidden rounded-md bg-background-200">
          <img
            src={item.poster}
            alt={`${item.title}海报`}
            title={`${item.title} 午夜影院影视详情`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="min-w-0">
          <p className="truncate text-sm font-medium text-foreground-950 group-hover:text-accent-700">
            {item.title}
          </p>
          <p className="mt-1 text-xs text-foreground-500">
            {item.year} · {item.region}
          </p>
          <p className="mt-1 flex items-center gap-1 font-label text-xs text-secondary-700">
            <i className="ri-star-fill text-secondary-500" />
            {item.rating.toFixed(1)}
          </p>
        </div>
      </Link>
    );
  }

  return (
    <article className="group cursor-pointer">
      <Link to={`/detail/${item.id}`} className="block">
        <div className="relative w-full overflow-hidden rounded-lg bg-background-200">
          <div className="aspect-[2/3] w-full">
            <img
              src={item.poster}
              alt={`${item.title}海报`}
              title={`${item.title} 午夜影院影视详情`}
              className="h-full w-full object-cover object-top transition-transform duration-700 ease-smooth group-hover:scale-[1.06]"
            />
          </div>

          <div className="absolute inset-0 bg-gradient-to-t from-primary-950/85 via-primary-950/10 to-transparent opacity-90" />

          <span className="absolute left-2 top-2 rounded-md bg-primary-950/85 px-2 py-1 font-label text-[11px] font-medium tracking-wide text-secondary-300 backdrop-blur-sm">
            {typeLabel(item.type)}
          </span>

          <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-1 font-label text-[11px] font-semibold text-primary-950">
            <i className="ri-star-fill text-[10px]" />
            {item.rating.toFixed(1)}
          </span>

          <div className="absolute inset-x-0 bottom-0 px-3 pb-3">
            <p className="line-clamp-1 text-xs text-background-200/90">
              {item.genres.slice(0, 2).join(" / ")}
            </p>
            <p className="mt-1 flex items-center gap-1 text-[11px] text-secondary-300 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
              查看详情
              <i className="ri-arrow-right-line" />
            </p>
          </div>
        </div>

        <div className="mt-3">
          <h3 className="line-clamp-1 text-sm font-medium text-foreground-950 transition-colors duration-300 group-hover:text-accent-700 md:text-[15px]">
            {item.title}
          </h3>
          <p className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
            <span className="font-label">{item.year}</span>
            <span className="text-foreground-300">·</span>
            <span>{item.region}</span>
            <span className="text-foreground-300">·</span>
            <span className="truncate">{item.duration}</span>
          </p>
        </div>
      </Link>
    </article>
  );
}